import { belgium, checkVAT } from '@accountable/jsvat';
import api from 'api/axiosInstance';
import { Nullable } from 'types/global.types';
const service = '/v2/users/verifications';

export enum IdentityProvider {
  Veriff = 'Veriff',
  Swan = 'Swan',
}

export enum IdentityStatus {
  approved = 'approved',
  resubmission_requested = 'resubmission_requested',
  declined = 'declined',
  expired = 'expired',
  abandoned = 'abandoned',
  review = 'review',
  not_started = 'not_started',
  submitted = 'submitted',
  started = 'started',
}

type Identity = {
  provider: IdentityProvider;
  status: IdentityStatus;
  sessionURL?: string;
  sessionId?: string;
  verifiedData?: {
    firstName: string;
    lastName: string;
  };
};

export enum CompanyProvider {
  KBO = 'KBO',
  local = 'local',
}

export enum CompanyStatus {
  approved = 'approved',
  declined = 'declined',
  not_started = 'not_started',
}

type Company = {
  provider: CompanyProvider;
  status: CompanyStatus;
  verifiedData?: {
    vatNumber: string;
    companyName: string;
    // IBAN?: string;
  };
};

type VerificationData = {
  _id: string;
  identity?: Identity;
  company?: Company;
};

export const getVerificationData = () => {
  return api
    .get<any, VerificationData | null>(`${service}`, {
      ignoreToast: true,
    })
    .then((data) => data || null)
    .catch((error) => {
      const is404 = error?.response?.status === 404;
      if (is404) return null;
      throw error;
    });
};

export const createVerification = (): Promise<VerificationData> => {
  return api.post(`${service}`);
};

export const startVerification = (): Promise<VerificationData> => {
  return getVerificationData().then(async (data) => {
    if (!data) {
      data = await createVerification();
    }

    const identityStatus = data.identity?.status;
    const companyStatus = data.company?.status;

    const isAlreadyDone =
      identityStatus === IdentityStatus.approved &&
      companyStatus === CompanyStatus.approved;

    if (isAlreadyDone) return data;

    const canResume =
      (identityStatus === IdentityStatus.resubmission_requested ||
        identityStatus === IdentityStatus.started) &&
      companyStatus !== CompanyStatus.not_started;

    if (canResume) return data;

    return api.put(`${service}/start`);
  });
};

export const resetVerification = (): Promise<void> => {
  return getVerificationData().then(async (data) => {
    if (!data) return;
    await api.put(`${service}/start`);
  });
};

export const getVerifiedBECompanyNames = (vatNumber: Nullable<string>) => {
  if (!vatNumber) return Promise.resolve([]);

  if (!checkVAT(vatNumber, [belgium]).isValid) {
    return Promise.resolve([]);
  }

  return api
    .get<any, { companyNames: string[] }>(
      `${service}/company-names/${vatNumber}`,
    )
    .then((data) => data.companyNames || []);
};
